import {
    Style
} from '@/libs/style.js';
import Chance from '@/utils/chance.js'
// import Core from '@/libs/src/core.js'
const $Chance = new Chance()
// 获取数据处理层的provider
// const DPC = Core.getProvider('DPC');

let DPC

let template = /*html*/ `<div class="xbt-show-data-container">
    <div class="show-data-header">
        <div>累计出水</div>
        <div class="throughput">18, 555, 111</div>
        <div>万吨</div>
    </div>
    <div class="data-list">
        <div class="data-item">
            <div class="chart-animate-cil">
                <div class="circle">
                    <div class="external" style="background:url(./images/xbt/1/external.png)no-repeat;background-size:100% auto;">
                    </div>
                    <div class="inside" style="background:url(./images/xbt/1/inside.png)no-repeat;background-size:100% auto;">
                    </div>
                    
                </div>
                <div class="data-text"><dv-digital-flop :config="{number:[26100]}" style="width:200px;height:30px;" /></div>
            </div>
            <div class="data-text-title">前一天进水量m³</div>
        </div>
        <div class="data-item">

            <div class="chart-animate-cil">
            <div class="circle">
                    <div class="external" style="background:url(./images/xbt/2/w.png)no-repeat;background-size:100% auto;">
                    </div>
                    <div class="inside" style="background:url(./images/xbt/2/inside.png)no-repeat;background-size:100% auto;">
                    </div>
                    
                </div>
                <div class="data-text"><dv-digital-flop :config="inWri" style="width:200px;height:30px;" /></div>
        </div>
        <div class="data-text-title">瞬时进水量m³</div>

        </div>
        <div class="data-item">
                <div class="chart-animate-cil">
                <div class="circle">
                    <div class="external" style="background:url(./images/xbt/3/w.png)no-repeat;background-size:100% auto;">
                    </div>
                    <div class="inside" style="background:url(./images/xbt/3/inside.png)no-repeat;background-size:100% auto;">
                    </div>
                </div>
                <div class="data-text"><dv-digital-flop :config="{number:[21100]}" style="width:200px;height:30px;" /></div>
            </div> 
            <div class="data-text-title">前一天出水量m³</div>
        </div>
        <div class="data-item">
                <div class="chart-animate-cil">
                <div class="circle">
                    <div class="external" style="background:url(./images/xbt/4/w.png)no-repeat;background-size:100% auto;">
                    </div>
                    <div class="inside" style="background:url(./images/xbt/4/inside.png)no-repeat;background-size:100% auto;">
                    </div>
                </div>
                <div class="data-text"><dv-digital-flop :config="outWri" style="width:200px;height:30px;" /></div>
            </div>
            <div class="data-text-title">瞬时出水量m³</div>
        </div>
    </div>
</div>`;

let style = /* css */ `.xbt-show-data-container{
    position: absolute;
    top: 5%;
    left: 50%;
    transform: translateX(-50%);
    width: 42%;
    height: 270px;
    overflow: hidden;
}

.xbt-show-data-container .show-data-header{
    background:linear-gradient(90deg, rgba(40, 84, 117, 0) 0%, #285475 50.82%, rgba(40, 84, 117, 0) 100%);
    height: 60px;
    color: #fff;
    display:flex;
    align-items:center;
    justify-content:space-around;
    font-size:24px;
}
.xbt-show-data-container .show-data-header .throughput{
    font-size:36px;
    color: #06EEA5;
}
.xbt-show-data-container .show-data-header img{
    margin:0 15px;
}
.xbt-show-data-container .data-list{
    display:flex;
    justify-content:space-around;
    padding:10px 0;
}
.xbt-show-data-container  .data-item{
    
    position:relative;
    color: #fff;
    display:flex;
    flex-direction:column;
    align-items:center;
    justify-content:center;
    
}
.xbt-show-data-container  .data-item .data-text-title{
    margin-top:15px;
    font-size:20px;
    color: #e2e2e2;
}
.xbt-show-data-container  .data-item .chart-animate-cil{
    height:90px;
    overflow: hidden;
    display:flex;
}
.xbt-show-data-container  .data-item .yran-decoration{
    width:120px;
    height:120px;
    transform:translateY(10%);
}
.xbt-show-data-container .data-text{
    position:absolute;
   text-align:center;
   bottom:35px;
   font-size:25px;
}
.xbt-show-data-container .border-radius-animate{
    width:124px;
    height:124px;
    border-radius:100%;
    background:linear-gradient(180deg, #188FF8 0%, #1BBFF8 100%);
    display:flex;
}
.xbt-show-data-container .border-radius-animate .inside-circle{
    width:100px;
    height:100px;
    background:#fff;
    border-radius:100%;
    margin:auto;
}
.xbt-show-data-container  .circle{
    width:180px;
    height:180px;
    position:relative;
    
}
.xbt-show-data-container .circle .external{
    width:120%;
    height:120%;
    position:absolute;
    left:50%;
    top:50%;
    transform-origin: left top;
    transform:translate(-50%,-50%);
    animation:forleft 5s linear infinite;
}
.xbt-show-data-container .chart-animate-cil{
    display:flex;
    justify-content:center;
}
.xbt-show-data-container .circle .inside{
    width:78%;
    height:78%;
    position:absolute;
    left:50%;
    top:50%;
    transform-origin: left top;
    transform:translate(-50%,-50%);
    animation:forright 10s linear infinite;
}
@keyframes forright{
    from{transform:rotate(0deg) translate(-50%,-50%);}
    to{transform:rotate(360deg) translate(-50%,-50%);}
}
@keyframes forleft{
    from{transform:rotate(0deg) translate(-50%,-50%);}
    to{transform:rotate(-360deg) translate(-50%,-50%);}
}
`;

export default (Vue) => {
    Vue.customElement('xbt-show-data', {
        template: template,
        data() {
            return {
                inWri: {
                    number: [8250]
                },
                outWri: {
                    number: [8450]
                }
            }
        },
        created() {
            DPC = this.$Core.getProvider('DPC');
            modules = DPC.modules;
            DPC
                .bindStatistics(DPC.threeDaysAgo(30), new Date())
                .then((res) => {
                    console.log('统计数据', res);
                    //   this.data = res;
                });
        },
        mounted() {
            Style(style);
            setInterval(() => {
                this.inWri = {
                    number: [this.randomCount(8000, 8500)]
                }
                this.outWri = {
                    number: [this.randomCount(8000, 8500)]
                }
            }, 5000)
        },
        methods: {
            randomCount(min, max) {
                let num = $Chance.integer({ min, max })
                return num
            }
        }
    });
}